import { InternalHeader } from "../../../../components/templates/InternalHeader";

export function ListSaleProducts() {
  return (
    <>
      <InternalHeader title="Produtos de Venda" />
    </>
  );
}
